import { connect } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './List.css'
import moment from 'moment'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { onClickRow, onReachBottom } from 'actions/library/promo'
import { getFormValues, isDirty } from 'redux-form'
import { askConfirmAction } from 'actions/confirm-action'
import { mapKeys, sortBy } from 'lodash'

class List extends React.Component {
  render () {
    let {promos, promoTypes, outlets, detailPromo} = this.props
    let hashedOutlets = mapKeys(outlets, 'id')
    return (
      <div className={styles.wrapper}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th className={styles.name}>
              Promo Name
            </th>
              <th className={styles.type}>
              Promo Type
            </th>
              <th className={styles.time}>
              Time Period
            </th>
              <th className={styles.outlet}>
              Outlet
            </th>
              <th className={styles.status}>
              Promo Status
            </th>
            </tr>
          </thead>
        </table>
        <div className={`${styles['table-content-wrapper']} promo-table-content-wrapper`}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}>
            <table className={styles['table-content']}>
              <tbody>
                {promos.length > 0 && promos.map((promo, idx) => {
                /**
                 * This temp will check if manager have access to that outlet or not
                 * Example -> Promo for outlet 1,2,3 but manager has access only 2,3
                 * In this case, popover should display outlet 2,3 and Others
                 */
                  let temp = 0
                  let outletName = []
                  promo.outlet_ids.map((outlet) => {
                    temp += !outlets.find(x => parseInt(x.id) === parseInt(outlet)) ? 1 : 0
                    if (outlets.find(x => parseInt(x.id) === parseInt(outlet))) {
                      outletName.push(hashedOutlets[outlet].name)
                    }
                  })

                  let sortedOutlet = sortBy(outletName)

                  const popover = (<Popover title='Assigned Outlet'>
                    <ul>
                      {sortedOutlet.map((outlet) => {
                        return <li>&bull; {outlet}</li>
                      })}
                      {
                      temp > 0 && <li>&bull; Others</li>
                    }
                    </ul>
                  </Popover>)

                  // Determine is promo active, ongoing, or inactive
                  let promoActive = promo.active
                  // Check promo date base on time period
                  let promoPeriod = null
                  // If have start_time, end_time, end_date, then it have time period
                  // Otherwise, it doesn't have time period
                  // HACK: If the promo has end_date, then it must have start_time and end_time
                  let promoStartDate = moment(promo.start_date).format('YYYY-MM-DD')
                  if (promo.end_date) {
                    let promoEndDate = moment(promo.end_date).format('YYYY-MM-DD')
                    promoPeriod = moment().isBetween(promoStartDate, promoEndDate, 'day', '[]') && moment().isSameOrBefore(promo.end_date)
                  } else {
                    promoPeriod = moment().isSameOrAfter(promoStartDate)
                  }

                  let statusText, statusTextClassName
                  if (moment().isBefore(promo.start_date) && promoActive) { // promo will be active (scheduled)
                    statusText = 'Scheduled'
                    statusTextClassName = styles['state-active']
                  } else if (promoActive && promoPeriod) {
                    statusText = 'Ongoing'
                    statusTextClassName = styles['state-ongoing']
                  } else {
                    statusText = 'Inactive'
                    statusTextClassName = styles['state-inactive']
                  }

                  return (
                    <tr key={idx} onClick={() => this._onClickRow(promo)}
                      className={`${(detailPromo && detailPromo.id === promo.id) ? styles['selected'] : ''}`}>
                      <td>{promo.name}</td>
                      <td>
                        {promoTypes.find(x => x.id === promo.promo_type_id).name}
                      </td>
                      <td>
                        {
                        promo.end_date
                          ? `${moment(promo.start_date).format('DD MMM YYYY')} - ${moment(promo.end_date).format('DD MMM YYYY')}`
                          : '-'
                      }
                      </td>
                      <td>
                        {promo.outlet_ids.length === 1 && outlets.find(x => parseInt(x.id) === parseInt(promo.outlet_ids[0])).name}
                        {promo.outlet_ids.length > 1 &&
                        <OverlayTrigger placement='top' overlay={popover}>
                          <button className='btn btn-info'>{`${promo.outlet_ids.length} Outlets`}</button>
                        </OverlayTrigger>}
                      </td>
                      <td className={statusTextClassName}>{statusText}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    )
  }

  _onReachBottom = () => {
    const {promos, currentPage, searchValues} = this.props
    let params = {
      promo_type_id: searchValues && searchValues.promoType && parseInt(searchValues.promoType) === 0 ? null : parseInt(searchValues.promoType),
      active: searchValues && searchValues.promoStatus && parseInt(searchValues.promoStatus) !== 0 ? parseInt(searchValues.promoStatus) === 1 : null,
      keyword: searchValues && searchValues.search ? searchValues.search : null,
      page: currentPage + 1, // make this dynamic
      per_page: 50
    }
    this.props.dispatch(onReachBottom(promos, params))
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onClickRow = (promo) => {
    const {promoTypes, outlets, isDirtyFirstForm, isDirtyFourthForm} = this.props
    // also need check the 4th form because on update mode user may in 4th form without making changes in first form.
    if (isDirtyFirstForm || isDirtyFourthForm) {
      this.props.dispatch(askConfirmAction(onClickRow(promo, promoTypes, outlets)))
    } else {
      this.props.dispatch(onClickRow(promo, promoTypes, outlets))
    }
  }
}

function mapStateToProps (state) {
  const {promos, promoTypes, outlets, detailPromo, currentPage, totalPage} = state.library.promo
  return {
    promos,
    promoTypes,
    outlets,
    detailPromo,
    currentPage,
    totalPage,
    searchValues: getFormValues('search')(state),
    isDirtyFirstForm: isDirty('promoTypeAndName')(state),
    isDirtyFourthForm: isDirty('promoConfig')(state)
  }
}

export default connect(mapStateToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/List/List.js